import { render } from "./PrioritySupport.vue?vue&type=template&id=53534f0d&scoped=true"
import script from "./PrioritySupport.vue?vue&type=script&lang=js"
export * from "./PrioritySupport.vue?vue&type=script&lang=js"

import "./PrioritySupport.vue?vue&type=style&index=0&id=53534f0d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53534f0d"]])

export default __exports__